export default __webpack_public_path__ + "images/35_thumbnail.jpg";